import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const AnimationOpacityIn300ms = trigger('opacityIn300ms', [
  transition(':enter', [
    style({
      opacity: '0',
    }),
    animate(
      '.3s',
      style({
        opacity: '1',
      }),
    ),
  ]),
]);

export const AnimationDisplayNone = trigger('detailExpand', [
  state('collapsed, void', style({ height: '0px', minHeight: '0' })),
  state('expanded', style({ height: '*' })),
  transition(
    'expanded <=> void, expanded <=> collapsed',
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
  ),
]);
